/* eslint-disable react/prop-types */
import React, { useState, useContext } from "react";
//Packages
import { isAuthenticated, login } from "./services/auth"; //import the login post
import { Navigate, Link, useNavigate } from "react-router-dom";
import { Col, Row, Button, Form, Container, Alert } from "react-bootstrap";
//Context
import { BusinessContextConsumer } from "../BusinessContext";
//Images and Icons
import { MdOutlineCancel, MdLogin } from "react-icons/md";
// Common
import FadeIn from "../common/FadeIn";

const AdminLogin = (props) => {
  // Handle Context
  const BusinessContext = useContext(BusinessContextConsumer);
  const businessID = BusinessContext.businessID;
  // Handle State
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  // Handle Clicks, Submits, Errors
  const [submitClicked, setSubmitClicked] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate(); // Navigate programmatically

  const submitLogin = async (e) => {
    e.preventDefault();
    const data = {
      email,
      password,
      businessID,
    };
    // Set the processing State
    setSubmitClicked(true);
    const token = await login(data);
    if (token.status === 200) {
      setSubmitClicked(false);
      await props.updateLoginKey();
      return navigate("/admin/overview/", { replace: true });
    } else {
      setSubmitClicked(false);
      return setErrorMessage("There was an error in your details.");
    }
  };

  // Dismiss Message
  const dismissMessages = () => {
    return setErrorMessage("");
  };

  return (
    <div className='AdminLoginForm'>
      {isAuthenticated() ? (
        <div>
          <h3 className='mt-5 text-center'>You are already logged in.</h3>
          <p className='mt-5 text-center'>
            <Navigate to='/admin/overview/' />
            <Link to='/admin/overview/'>Go To Overview</Link>
          </p>
        </div>
      ) : (
        <FadeIn delay={250} duration={450}>
          <Container>
            <Row>
              <Col sm='12'>
                <Form onSubmit={submitLogin} className='shadow p-4 loginForm mx-auto'>
                  <h3>Login: Administrator</h3>
                  <Row className='mt-3'>
                    <Col sm='12'>
                      <Form.Group controlId='email'>
                        <Form.Label>Email:</Form.Label>
                        <Form.Control
                          type='email'
                          maxLength='256'
                          placeholder='you@yourdomain.com'
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          className='border'
                          required
                        />
                        <Form.Text className='text-muted'>
                          The admin email we set up for Signaclass.
                        </Form.Text>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row className='mt-3 mb-3'>
                    <Col sm='12'>
                      <Form.Group controlId='password'>
                        <Form.Label>Password:</Form.Label>
                        <Form.Control
                          type='password'
                          maxLength='256'
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                          className='border'
                          required
                        />
                        <Form.Text className='text-muted'>Your password.</Form.Text>
                      </Form.Group>
                    </Col>
                  </Row>
                  <div>
                    <CustomStatusBlock errorMessage={errorMessage} dismissMessages={dismissMessages} />
                  </div>
                  {submitClicked && errorMessage.length !== "" ? (
                    <Button variant='secondary' size='lg' type='submit' disabled className='mb-3'>
                      Processing
                    </Button>
                  ) : (
                    <Button
                      variant='primary'
                      size='lg'
                      type='submit'
                      className='mb-3'
                    >
                      Login <MdLogin />
                    </Button>
                  )}
                  <div>
                    <Link to='/admin/reset'>Reset Password</Link>.
                  </div>
                </Form>
              </Col>
            </Row>
          </Container>
        </FadeIn>
      )}
    </div>
  );
};

const CustomStatusBlock = (props) => {
  const dismiss = () => {
    props.dismissMessages();
  };

  if (props.errorMessage !== "") {
    return (
      <Alert variant='danger' className='mb-3'>
        {props.errorMessage}{" "}
        <Button variant='secondary' size='sm' onClick={dismiss}>
          dismiss <MdOutlineCancel />
        </Button>
      </Alert>
    );
  } else {
    return " ";
  }
};

export default AdminLogin;
